export default __webpack_public_path__ + "static/media/mo_background.01a92d7d.png";